module.exports = __webpack_public_path__ + "static/img/carousel1.f43c4afc.jpg";